const ovanaReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initOvanaSlider(slider) {
  if (slider.dataset.ovanaReady === 'true') return;
  slider.dataset.ovanaReady = 'true';
  const track = slider.querySelector('[data-ovana-track]');
  const slides = [...slider.querySelectorAll('[data-ovana-slide]')];
  const dots = slider.querySelector('[data-ovana-dots]');
  const prev = slider.querySelector('[data-ovana-prev]');
  const next = slider.querySelector('[data-ovana-next]');
  if (!track || slides.length < 2) return;

  let current = 0;
  let timer;
  let startX = null;
  let startY = null;
  const dotButtons = slides.map((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.setAttribute('aria-label', `Show slide ${index + 1} of ${slides.length}`);
    dot.addEventListener('click', () => { go(index); play(); });
    dots?.append(dot);
    return dot;
  });

  function go(index) {
    current = (index + slides.length) % slides.length;
    slider.style.setProperty('--ob-desktop-ratio', slides[current].dataset.desktopAspect || '1.777');
    slider.style.setProperty('--ob-mobile-ratio', slides[current].dataset.mobileAspect || '1.777');
    track.style.transform = `translateX(-${current * 100}%)`;
    slides.forEach((slide, slideIndex) => {
      if (slideIndex === current) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
      slide.querySelectorAll('a, button').forEach((control) => {
        if (slideIndex === current) control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', '-1');
      });
    });
    dotButtons.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === current);
      if (dotIndex === current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
  slider.ovanaGoTo = go;
  prev?.addEventListener('click', () => { go(current - 1); play(); });
  next?.addEventListener('click', () => { go(current + 1); play(); });

  function stop() {
    if (timer) clearInterval(timer);
    timer = undefined;
  }
  function play() {
    stop();
    if (slider.dataset.autoplay !== 'true' || ovanaReducedMotion.matches || document.hidden) return;
    timer = setInterval(() => {
      if (!slider.isConnected) { stop(); return; }
      go(current + 1);
    }, Number(slider.dataset.interval) || 10000);
  }

  slider.addEventListener('pointerdown', (event) => { startX = event.clientX; startY = event.clientY; stop(); });
  slider.addEventListener('pointerup', (event) => {
    if (startX !== null && Math.abs(event.clientX - startX) > 40 && Math.abs(event.clientX - startX) > Math.abs(event.clientY - startY)) {
      go(current + (event.clientX < startX ? 1 : -1));
    }
    startX = null;
    startY = null;
    play();
  });
  slider.addEventListener('pointercancel', () => { startX = null; startY = null; play(); });
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', play);
  slider.addEventListener('focusin', stop);
  slider.addEventListener('focusout', (event) => { if (!slider.contains(event.relatedTarget)) play(); });
  document.addEventListener('visibilitychange', play);
  ovanaReducedMotion.addEventListener?.('change', play);
  go(0);
  play();
}

function initOvanaSliders(root = document) {
  root.querySelectorAll('[data-ovana-slider]').forEach(initOvanaSlider);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initOvanaSliders(), { once: true });
else initOvanaSliders();
document.addEventListener('shopify:section:load', (event) => initOvanaSliders(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('[data-ovana-slide]');
  const slider = slide?.closest('[data-ovana-slider]');
  if (slider?.ovanaGoTo) slider.ovanaGoTo([...slider.querySelectorAll('[data-ovana-slide]')].indexOf(slide));
});
